export default __webpack_public_path__ + "static/media/glr-9.3d4e6cb9.webp";